import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthenticationService } from '../../service/authentication.service';
import { CommonService } from "../../service/common.service";
import { EventEmitterService } from '../../service/event-emitter.service';

import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

import {Istanza} from '../../models/istanza';

@Component({
  selector: 'app-homepageorfri',
  templateUrl: './homepageorfri.component.html',
  styleUrls: ['./homepageorfri.component.css']
})
export class HomepageorfriComponent implements OnInit {

  constructor(private commonService: CommonService,
    private eventEmitterService: EventEmitterService,
    private router: Router) { }

  ngOnInit() {
    //console.log("Set istanza Orfri");
     this.commonService.currentIstanza=new Istanza();
    this.commonService.currentIstanza.Codice=6;
    this.commonService.currentIstanza.Nome="Orfri";
    //alert("Istanza Orfri settata");
    this.router.navigate(['login']);
  }
}
